import BarChart from "@arelia-components/ui-atoms/BarChart";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Card, CardContent, CardHeader } from "@mui/material";

type Props = {
  data: { label: string; value: number }[];
  loading: boolean;
};

export function ViewsBarchart({ data, loading }: Props) {
  return <Card sx={styles.card}>
    <CardHeader
      title="Total Views"
    />
    <CardContent>
      <SpinnerWrapper loading={loading}>
        <BarChart
          data={data}
          yAxisFormatter={(value: number) => `${value}`}
          labelFormatter={({ formattedValue }: any) => `${formattedValue}`}
        />
      </SpinnerWrapper>
    </CardContent>
  </Card>;
}

const styles = {
  card: {
    gridColumn: "span 6",
    gridRow: "span 6",
  }
};